import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";
import { setTemplateRegistry } from "@/lib/templates";

const SiteCtx = createContext(null);
const CACHE = "lk_site_cache";
const readCache = () => { try { return JSON.parse(localStorage.getItem(CACHE)); } catch { return null; } };

export const SiteProvider = ({ children }) => {
  const cached = readCache();
  if (cached?.templates) setTemplateRegistry(cached.templates);
  const [settings, setSettings] = useState(cached?.settings || {});
  const [sections, setSections] = useState(cached?.sections || []);
  const [series, setSeries] = useState(cached?.series || []);
  const [ready, setReady] = useState(!!cached);

  const refresh = useCallback(async () => {
    const [s, sec, ser, tpl] = await Promise.all([api.get("/settings"), api.get("/sections"), api.get("/series"), api.get("/templates")]);
    setTemplateRegistry(tpl.data);
    setSettings(s.data);
    setSections(sec.data);
    setSeries(ser.data);
    setReady(true);
    try { localStorage.setItem(CACHE, JSON.stringify({ settings: s.data, sections: sec.data, series: ser.data, templates: tpl.data })); } catch { /* storage full */ }
  }, []);

  useEffect(() => {
    refresh().catch(() => setReady(true));
  }, [refresh]);

  useEffect(() => {
    if (settings.site_title) document.title = settings.site_title;
  }, [settings.site_title]);

  return <SiteCtx.Provider value={{ settings, sections, series, ready, refresh }}>{ready ? children : <div data-testid="site-loading" className="min-h-screen" />}</SiteCtx.Provider>;
};

export const useSite = () => useContext(SiteCtx);
